/*eslint-disable*/
import React, { Component } from "react";
import HeaderItems from "./header_items";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { translate } from "react-i18next";
import { FEATURES } from "../../utils/constant";

class HeaderMenu extends Component {
  handleRedirect = (alt) => {
    let name = alt ? alt : "";

    let customerNo = +localStorage.getItem("customerNumber");
    switch (name) {
      case "planning":
        let planningUrl = ''
        if(FEATURES.flutterOEEnabled){
          planningUrl = `${process.env.REACT_APP_FLUTTER_URL_OE}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        }else{
          planningUrl = `${process.env.REACT_APP_OE}?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}`;
        }
        window.open(planningUrl, "_blank");
        break;

      case "allocation":
        //let allocationUrl = `${process.env.REACT_APP_SPEED}/index?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}&product_Id=${name}`;
        let allocationUrl = process.env.REACT_APP_TA;
        window.open(allocationUrl, "_blank");
        break;

      case "consignor":
        if (FEATURES.flutterConsignorModuleEnabled) {
            let consignorUrl = `${process.env.REACT_APP_FLUTTER_URL_CONSIGNOR}?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}`;
            window.open(consignorUrl, "_blank");
        }
        // if (customerNo !== 1123) {
        //   let consignorUrl = `${process.env.REACT_APP_TA}?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}&prodCode=${name}`;
        //   window.open(consignorUrl, "_blank");
        // }
        break;

      case "tracking":
        let trackingUrl
        if(FEATURES.flutterDTEnabled){
          trackingUrl = `${process.env.REACT_APP_FLUTTER_URL_DT}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        }else{
          trackingUrl = `${process.env.REACT_APP_DT}?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}&prodCode=${name}`;
        }
        
        window.open(trackingUrl, "_blank");
        break;

      case "consignee":
        if (FEATURES.flutterConsigneeModuleEnabled) {
          let consigneeUrl = `${process.env.REACT_APP_FLUTTER_URL_CONSIGNEE}?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}`;
          window.open(consigneeUrl, "_blank");
        }
        // let consigneeUrl = `${process.env.REACT_APP_DT}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        // window.open(consigneeUrl, "_blank");
        break;

      case "billing":
        let billingUrl
        if(FEATURES.flutterBillingEnabled){
          billingUrl = `${process.env.REACT_APP_FLUTTER_URL_BILLING}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        }else{
          billingUrl = `${process.env.REACT_APP_Bill}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        }
        window.open(billingUrl, "_blank");
        break;

      case "partnerOnboarding":
        let partnerOnboarding = `${process.env.REACT_APP_ONBOARDING}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        window.open(partnerOnboarding, "_blank");
        break;

      case "gps":
        let speedUrl = `${process.env.REACT_APP_SPEED}/modules/realtimedata/validate.php?userkey=${this.props.auth.userKey}`;
        window.open(speedUrl, "_blank");
        break;

      case "warehouse":
        // let warehouseUrl = `${process.env.REACT_APP_INVENTORY}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        // window.open(warehouseUrl, "_blank");
        break;

      case "mobileTracking":
        // let mobileTrackingUrl = `${process.env.REACT_APP_ONBOARDING}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        // window.open(mobileTrackingUrl, "_blank");
        break;

      case "analytics":
        // let analyticsUrl = `${process.env.REACT_APP_ONBOARDING}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        // window.open(analyticsUrl, "_blank");
        break;

      case "fleet":
        let fleetUrl = `${process.env.REACT_APP_FLEET}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        window.open(fleetUrl, "_blank");
        break;

      case "invoicing":
        let invoicingUrl
        if(FEATURES.flutterSalesEnabled){
          invoicingUrl = `${process.env.REACT_APP_FLUTTER_URL_SALES}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        }else{
          invoicingUrl = `${process.env.REACT_APP_SALE}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        }
        window.open(invoicingUrl, "_blank");
        break;

      case "inventory":
        let inventoryUrl = `${process.env.REACT_APP_INVENTORY}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        window.open(inventoryUrl, "_blank");
        break;

      case "books":
        // let booksUrl = `${process.env.REACT_APP_Bill}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        // window.open(booksUrl, "_blank");
        break;

      case "support":
        let supportUrl = `${process.env.REACT_APP_SUPPORT}/index?userKey=${this.props.auth.userKey}&token=${this.props.auth.speedToken}&product_Id=${name}`;
        window.open(supportUrl, "_blank");
        break;

      case "rateEngine":
        let rateEngineUrl = `${process.env.REACT_APP_RATES}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        window.open(rateEngineUrl, "_blank");
        break;

      case "marketplace":
        // let marketplaceUrl = `${process.env.REACT_APP_ONBOARDING}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        // window.open(marketplaceUrl, "_blank");
        break;

      /* case "speed":
        let speedUrl = `${process.env.REACT_APP_SPEED}/modules/map/map.php?userkey=${this.props.auth.userKey}&prodCode=${name}`;
        window.open(speedUrl, "_blank");
        break; */

      case "radar":
        // let radarUrl = `${process.env.REACT_APP_ONBOARDING}?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}`;
        // window.open(radarUrl, "_blank");
        break;

      case "monitor":
        // let monitorUrl = `${process.env.REACT_APP_SPEED}/modules/user/route.php?token=${this.props.auth.speedToken}&userKey=${this.props.auth.userKey}&prodCode=${name}`;
        // window.open(monitorUrl, "_blank");
        break;

      default:
        break;
    }
  };

  render() {
    const customerNo = localStorage.getItem("customerNumber");

    const planningAccess = [
      984, 549, 1175, 549, 1254, 20, 1158, 1183, 1330, 1323, 1075, 1278,
      1279, 1327, 701, 503, 1543, 1114, 1568,1931, 1922
    ].includes(Number(customerNo));

    const allocationAccess = [984].includes(Number(customerNo));

    const consignorAccess = [
      1122, 1165, 984, 1167, 1175, 1254, 20, 1158, 1077, 1183, 1330, 1323, 1278,
      1279, 503, 1543
    ].includes(Number(customerNo));

    const trackingAccess = [1122,1931].includes(Number(customerNo));
    const consigneeAccess = [1122, 984, 1183, 1330, 1323, 1278, 1279, 503, 1543].includes(
      Number(customerNo)
    );

    const billingAccess = [
      1122, 984, 1167, 1123, 1077, 1183, 1323, 1278, 1279, 1279, 1920
    ].includes(Number(customerNo));

    const gpsAccess = [
      984, 1123, 1122, 1166, 1165, 1167, 549, 1175, 1254, 20, 1077, 1153,
      1323, 1305, 1330, 1183, 1075, 1278, 1279, 1327, 701, 1543, 1114, 1568, 1532,1931, 1922, 1920
    ].includes(Number(customerNo));

    const warehouseAccess = true;
    const mobileTrackingAccess = true;
    const analyticsAccess = true;
    const fleetAccess = [
      984, 1122, 1166, 1165, 1167, 1158, 1123, 1077, 1183, 1330, 1305, 1323,
      1278, 1279, 701, 1543, 1568, 1532,1931, 1922, 1920
    ].includes(Number(customerNo));

    const invoicingAccess = [
      1122,
      1166,
      1165,
      984,
      1167,
      1158,
      1123,
      1077,
      1183,
      1330,
      1305,
      1323,
      1278,
      1279,
      1254,
      1175,
      20,
      1123,
      1153,
      1075,
      701, //1327,
      1543, 
      1532,
      1922,
      1920
    ].includes(Number(customerNo));

    const inventoryAccess = [
      984, 1122, 1166, 1165, 1167, 549, 1175, 1254, 1158, 1123, 1077, 1183, 503,
      1323, 1305, 1330, 1278, 1279, 701, 1543, 1568, 1114, 1532 ,1931, 1922, 1920
    ].includes(Number(customerNo));

    const booksAccess = true;

    const rateEngineAccess = [
      1122, 984, 1167, 1158, 1123, 1077, 1183, 1305, 1158, 1532, 1920
    ].includes(Number(customerNo));

    const partnerOnboarding = [
      1158, 1543
    ].includes(Number(customerNo));

    const consignorModuleEnabled = [1654, 1922, 1920, 1562].includes(Number(customerNo));

    const consigneeModuleEnabled = [1922, 1920, 1562, 1166].includes(Number(customerNo));

    const marketPlaceAccess = true;
    const supportAccess = [1931,1922].includes(Number(customerNo));;
    const monitorAccess = [984, 1543].includes(Number(customerNo));

    return (
      <React.Fragment>
        <div className="" id="">
          {this.props?.auth?.role != "Vendor" ? (
            <>
              <ul className="navbar-nav">
                <li
                  className="nav-item dropdown "
                  style={{ margin: "0px", padding: "0px" }}
                >
                  <Link
                    className="nav-link"
                    to="#"
                    id="navbarDropdownMenuLink"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="true"
                  >
                    <img
                      className="mt-0"
                      src="assets/svg/tool.svg"
                      alt="icon"
                      width="15px"
                    />
                  </Link>
                  <div
                    className="dropdown-menu dropdown-menu-right griddrop p-2"
                    aria-labelledby="navbarDropdownMenuLink"
                  >
                    <div className="row text-center p-2">
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Planning.svg"
                        altName={planningAccess ? "" : "planning"} //"planning"
                        items="Planning"
                        handleRedirect={this.handleRedirect}
                        styleClass={planningAccess ? "p-notallow" : ""}
                      //disabled={planningAccess ? "ture" : "false"}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Allocation.svg"
                        altName={allocationAccess ? "" : "allocation"} //"allocation"
                        items="Allocation"
                        handleRedirect={this.handleRedirect}
                        styleClass={allocationAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Consignor.svg"
                        //altName={consignorAccess ? "" : "consignor"} //"consignor"
                        altName={consignorModuleEnabled ? "consignor":""} //"consignor"
                        items="Consignor"
                        handleRedirect={this.handleRedirect}
                        //styleClass={consignorAccess ? "p-notallow" : ""}
                        styleClass={consignorModuleEnabled ? "" : "p-notallow"}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Tracking.svg"
                        altName={trackingAccess ? "" : "tracking"} //"tracking"
                        items="Tracking"
                        handleRedirect={this.handleRedirect}
                        styleClass={trackingAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Consignee.svg"
                        //altName={consigneeAccess ? "" : "consignee"} //"consignee"
                        altName={consigneeModuleEnabled ? "consignee":""} //"consignee"
                        items="Consignee"
                        handleRedirect={this.handleRedirect}
                        //styleClass={consigneeAccess ? "p-notallow" : ""}
                        styleClass={consigneeModuleEnabled ? "" : "p-notallow"}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Billing.svg"
                        altName={billingAccess ? "" : "billing"} //"billing"
                        items="Billing"
                        handleRedirect={this.handleRedirect}
                        styleClass={billingAccess ? "p-notallow" : ""}
                      />
                      {+localStorage.getItem("customerNumber") == 1158 ?
                        <HeaderItems
                          imgLink="assets/svg/partnerOnboarding.svg "
                          altName={partnerOnboarding ? "partnerOnboarding" : ""} //"partnerOnboarding"
                          items="Partner Onboarding"
                          handleRedirect={this.handleRedirect}
                          styleClass={partnerOnboarding ? "" : "p-notallow"}
                        /> : null}
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/GPS.svg"
                        altName={gpsAccess ? "" : "gps"} //"gps"
                        items="GPS"
                        handleRedirect={this.handleRedirect}
                        styleClass={gpsAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Warehouse.svg"
                        altName={warehouseAccess ? "" : "warehouse"} //"warehouse"
                        items="Warehouse"
                        handleRedirect={this.handleRedirect}
                        styleClass={warehouseAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Mobile Tracking.svg"
                        altName={mobileTrackingAccess ? "" : "mobileTracking"} //"mobileTracking"
                        items="Mobile Tracking"
                        handleRedirect={this.handleRedirect}
                        styleClass={mobileTrackingAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Analytics.svg"
                        altName={analyticsAccess ? "" : "analytics"} //"analytics"
                        items="Analytics"
                        handleRedirect={this.handleRedirect}
                        styleClass={analyticsAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Fleet.svg"
                        altName={fleetAccess ? "" : "fleet"} //"fleet"
                        items="Fleet"
                        handleRedirect={this.handleRedirect}
                        styleClass={fleetAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Invoicing.svg"
                        altName={invoicingAccess ? "" : "invoicing"} //"invoicing"
                        items="Invoicing"
                        handleRedirect={this.handleRedirect}
                        styleClass={invoicingAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Inventory.svg"
                        altName={inventoryAccess ? "" : "inventory"} //"inventory"
                        items="Inventory"
                        handleRedirect={this.handleRedirect}
                        styleClass={inventoryAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Books.svg"
                        altName={booksAccess ? "" : "books"} //"books"
                        items="Books"
                        handleRedirect={this.handleRedirect}
                        styleClass={booksAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/support.svg"
                        altName={supportAccess ? "" : "support"} //"support"
                        items="Support"
                        handleRedirect={this.handleRedirect}
                        styleClass={supportAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Rate Engine.svg"
                        altName={rateEngineAccess ? "" : "rateEngine"} //"rateEngine"
                        items="Rate Engine"
                        handleRedirect={this.handleRedirect}
                        styleClass={rateEngineAccess ? "p-notallow" : ""}
                      />
                      <HeaderItems
                        imgLink="assets/svg/productSwitch/Marketplace.svg"
                        altName={marketPlaceAccess ? "" : "marketPlace"} //"marketPlace"
                        items="Market Place"
                        handleRedirect={this.handleRedirect}
                        styleClass={
                          marketPlaceAccess
                            ? "p-notallow height-42px"
                            : "height-42px"
                        }
                      />
                      {/* <HeaderItems imgLink="assets/svg/productSwitch/monitor.svg" altName="mont" items="Monitor" handleRedirect={this.handleRedirect} styleClass={monitorAccess ? "p-notallow" : ""}/>                                 */}
                    </div>
                  </div>
                </li>
              </ul>
            </>
          ) : null}
        </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({ auth }) => {
  return { auth };
};

export default connect(mapStateToProps)(
  translate("application_menu")(HeaderMenu)
);
